import { graphql } from "gql.tada";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { LinkFragment } from "@queries/fragments/LinkFragment";
import { IconGridFragment } from "@queries/fragments/IconGridFragment";
import { ThemeFragment } from "@queries/fragments/ThemeFragment";
import { MetadataFragment } from "@queries/fragments/MetadataFragment";

const SolutionsRowFragment = graphql(
  /* GraphQL */ `
    fragment SolutionsRowInlineFragment on SolutionsChapterRow {
      _id
      title
      eyebrow
      rowType
      collapsible
      ctaEvent
      ctaLink {
        ...LinkFragment
      }
      bodyRichText {
        ...RichEntryFragment
      }
    }
  `,
  [LinkFragment, RichEntryFragment]
);

const SolutionsChapterFragment = graphql(
  /* GraphQL */ `
    fragment SolutionsChapterInlineFragment on SolutionsChapter {
      _id
      title
      eyebrow
      menuLabel
      ctaEvent
      ctaLink {
        ...LinkFragment
      }
      media {
        url
        contentType
      }
      mediaSourceRichText {
        ...RichEntryFragment
      }
      mediaBodyRichText {
        ...RichEntryFragment
      }
      mediaHeading
      mediaLayout
      iconGrid {
        ...IconGridFragment
      }
      rowsCollection(limit: 10) {
        items {
          ...SolutionsRowInlineFragment
        }
      }
    }
  `,
  [SolutionsRowFragment, IconGridFragment, RichEntryFragment]
);

export const GetProductPageById = graphql(
  `
    query GetProductPageById($id: String!, $locale: String, $preview: Boolean) {
      productPage(id: $id, preview: $preview, locale: $locale) {
        __typename
        slug
        title
        theme { ...ThemeFragment }
        metadata { ...MetadataFragment }
        markets
        navigationAccessibilityLabel
        hero {
          variant
          title
          subtitle
          description
          ctaText
          ctaLink
          backgroundImage {
            url
            contentType
          }
          previewVideo {
            url
            contentType
          }
          fullVideo {
            url
            contentType
          }
          overlayImage {
            url
          }
          eyebrowImagesCollection {
            items {
              url
              contentType
            }
          }
          bodyRichText {
            ...RichEntryFragment
          }
          fullWidthImage {
            url
            contentType
          }
        }
        solutions {
          _id
          title
          chaptersCollection(limit: 6) {
            items {
              ...SolutionsChapterInlineFragment
            }
          }
        }
        routing {
          sys {
            id
          }
          variant
          isVertical
          title
          titleRichText {
            json
          }
          cta {
            ...LinkFragment
          }
          backgroundImage {
            url
            title
          }
        }
        legal {
          __typename
          ... on IconCtaSection {
            _id
            title
            description
            variant
            ctaLink {
              ...LinkFragment
            }
            iconGrid {
              ...IconGridFragment
            }
          }
        }
      }
    }
  `,
  [RichEntryFragment, LinkFragment, SolutionsChapterFragment, IconGridFragment, ThemeFragment, MetadataFragment]
);
